import _ from 'lodash';

const podstawaPrawna = {
  'Ustawa z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20030800717',
  'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20062251635',
  'Ustawa z dnia 6 września 2001 r. o dostępie do informacji publicznej.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20011121198',
  'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU19600300168',
};
const trybOdwolawczy = 'Jeśli urząd nie załatwi Twojej sprawy w terminie to możesz złożyć zażalenie. Złóż je do samorządowego kolegium odwoławczego. Reguluje to art. 37 § 1 k.p.a.';
const czas14dni = 'Urząd ma 14 dni na wydanie wypisu i wyrysu – zgodnie z art. 13 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej.';

export const Sprawy = {
  ZaswiadczenieMPZP: {
    title: 'Wniosek o wydanie zaświadczenia o przeznaczeniu w miejscowym planie zagospodarowania przestrzennego działki. ',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uzyskanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego.',
    czas:  'Urząd ma 14 dni na wydanie zaświadczenia – zgodnie z art. 13 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej.',
    dokumenty: ['Wniosek o wydanie zaświadczenia z miejscowego planu zagospodarowania przestrzennego',
      'Dowód uiszczenia opłaty skarbowej'],
    oplaty: ['Pozostałe zaświadczenia: 17 zł'],
    tryb: trybOdwolawczy,
    podstawa: podstawaPrawna,
  },
  WypisIWyrysZeStudium: {
    title: 'Wniosek o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego.',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uzyskanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego.',
    czas: czas14dni,
    dokumenty: ['Wniosek o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
      'Dowód uiszczenia opłaty skarbowej'],
    oplaty: ['Opłata od wypisu: do 5 stron – 30 zł, powyżej 5 stron – 50 zł.',
      'Za każdą wchodzącą w skład wyrysu pełną lub rozpoczętą część odpowiadającą stronie formatu A4 - 20 zł',
      'Nie więcej niż 200 zł'],
    tryb: trybOdwolawczy,
    podstawa: podstawaPrawna,
  },
  WypisIWyrysZMpzp: {
    title: 'Wniosek o wydanie wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uzyskanie wypisu i wyrysu w miejscowym planie zagospodarowania przestrzennego.',
    czas: czas14dni,
    dokumenty: ['Wniosek o wydanie zaświadczenia o przeznaczeniu w miejscowym planie zagospodarowania przestrzennego',
      'Dowód uiszczenia opłaty skarbowej'],
    oplaty: ['Opłata od wypisu: do 5 stron – 30 zł, powyżej 5 stron – 50 zł.',
      'Za każdą wchodzącą w skład wyrysu pełną lub rozpoczętą część odpowiadającą stronie formatu A4 - 20 zł',
      'Nie więcej niż 200 zł'],
    tryb: trybOdwolawczy,
    podstawa: podstawaPrawna,
  },
  NrIPowDzialkiInfo: {
    title: 'Pozyskiwanie informacji o numerach działek i ich powierzchniach.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o numerach działek i ich powierzchni.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
  },
  WlasnoscDzialkiInfo: {
    title: 'Pozyskiwanie informacji o właścicielach/własności działek.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o właścicielach/własności działek.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
  },
  ZagospDzialkiInfo: {
    title: 'Sprawdzenie sposobu zagospodarowania poszczególnych działek.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o zagospodarowaniu poszczególnych działek.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
  },
  PrzebiegDrogiInfo: {
    title: 'Pozyskanie informacji o przebiegu i numeracji dróg gminnych. ',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o przebiegu i numeracji dróg gminnych.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
  },
  ZimoweUtrzymanieDrog: {
    title: 'Pozyskanie informacji o zimowym utrzymaniu dróg.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o zimowym utrzymaniu dróg.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
  },
  PobierzWMSiWFS: {
    title: 'Usługa pobrania WMS i WFS.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem dostępu do usług WMS i WFS.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.assign(_.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
      { 'Ustawa z dnia 4 marca 2010 r. o infrastrukturze informacji przestrzennej.': 'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20100760489' }),
  },
  PobierzWFSiWMS: {
    title: 'Usługa pobrania WFS i WMS.',
    dotyczy:'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem dostępu do usług WMS i WFS.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.assign(_.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
      { 'Ustawa z dnia 4 marca 2010 r. o infrastrukturze informacji przestrzennej.': 'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20100760489' }),
  },
  UproszczWypis: {
    title: 'Wniosek o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uzyskanie uproszczonego wypisu z miejscowego planu zagospodarowania przestrzennego.',
    czas:  'Urząd ma 14 dni na wydanie uproszczonego wypisu – zgodnie z art. 13 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej.',
    dokumenty: ['Wniosek o wydanie uproszczonego wypisu z miejscowego planu zagospodarowania przestrzennego.',
      'Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['Opłata od wypisu: do 5 stron – 30 zł, powyżej 5 stron – 50 zł.',
      'Za każdą wchodzącą w skład wyrysu pełną lub rozpoczętą część odpowiadającą stronie formatu A4 - 20 zł',
      'Nie więcej niż 200 zł'],
    tryb: trybOdwolawczy,
    podstawa: podstawaPrawna,
  },
  ZgodnoscMPZP: {
    title: 'Wniosek o zaświadczenie o zgodności zmiany sposobu użytkowania obiektu budowlanego z ustaleniami miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zaświadczenie o zgodności zmiany sposobu użytkowania obiektu budowlanego z ustaleniami miejscowego planu zagospodarowania przestrzennego.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o zaświadczenie o zgodności zmiany sposobu użytkowania obiektu budowlanego z ustaleniami miejscowego planu zagospodarowania przestrzennego', 'Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  WniosekUproszczonyWypis: {
    title: 'Wniosek o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  ZaswiadczenieFormOchrony: {
    title: 'Wniosek o wydanie zaświadczenia o lokalizacji na danej nieruchomości form ochrony przyrody',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zaświadzczenie o lokalizacji na danej nieruchomości form ochrony przyrody.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  ZaswiadczenieStrefOchronnych: {
    title: 'Wniosek o wydanie zaświadczenia o lokalizacji na danej nieruchomości stref ochronnych',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zaświadzczenie o lokalizacji na danej nieruchomości stref ochronnych.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  OpiniaPodzialu: {
    title: 'Wniosek o opinię w sprawie zgodności podziału nieruchomości z ustaleniami MPZP',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o opinię w sprawie zgodności podziału nieruchomości z ustaleniami MPZP.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o opinię w sprawie zgodności podziału nieruchomości z ustaleniami MPZP'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  WniosekPomnikPrzyrody: {
    title: 'Wniosek o ustalenie pomnika ochrony przyrody',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o ustalenie pomnika ochrony przyrody.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o ustalenie pomnika ochrony przyrody'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  SprzedazNieruchomosci: {
    title: 'Wniosek o sprzedaż nieruchomości lub jej części',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o kupno nieruchomości lub jej części.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o sprzedaż nieruchomości lub jej części'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZmianaMPZP: {
    title: 'Wniosek o zmianę miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zmianę miejscowego planu zagospodarowania przestrzennego.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o zmianę miejscowego planu zagospodarowania przestrzennego'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
  },
  DzierzawaNieruchomosci: {
    title: 'Wniosek o dzierżawę nieruchomości lub jej części',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o dzierżawę nieruchomości lub jej części',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o dzierżawę nieruchomości lub jej części'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  UwagiProceduryPlanistycznej: {
    title: 'Uwagi do procedury planistycznej',
    dotyczy: 'Osoby fizyczne i osoby prawne składające uwagi do procedury planistycznej',
    czas: 'Nie określono.',
    dokumenty: ['Uwaga do procedury planistycznej'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  UwagiMPZP: {
    title: 'Uwagi do projektu miejscowego planu zagospodarowania przestrzennego w okresie jego wyłożenia do publicznego wglądu',
    dotyczy: 'Osoby fizyczne i osoby prawne składające uwagi do projektu miejscowego planu zagospodarowania przestrzennego w okresie jego wyłożenia do publicznego wglądu.',
    czas: 'Nie określono.',
    dokumenty: ['Uwagi do projektu miejscowego planu zagospodarowania przestrzennego w okresie jego wyłożenia do publicznego wglądu'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  DecyzjaSrodowiskowa: {
    title: 'Wniosek o wydanie decyzji o środowiskowych uwarunkowaniach',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['205 zł'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  DecyzjeULICP: {
    title: 'Wniosek o wydanie decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['107 zł'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  DecyzjeWZ: {
    title: 'Wniosek o wydanie decyzji o warunkach zabudowy',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['107 zł'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  OplataPlanistyczna: {
    title: 'Wniosek o ustalenie opłaty planistycznej przed zbyciem nieruchomości',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  PrzeniesienieDecyzjiOWarunkachZabudowy: {
    title: 'Wniosek o przeniesienie decyzji o warunkach zabudowy na rzecz innej osoby',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['56 zł'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  PrzeniesienieSrodowiskowychUwarunkowan: {
    title: 'Wniosek o przeniesienie decyzji o środowiskowych uwarunkowaniach',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  SporzadzenieMPZP: {
    title: 'Wniosek o sporządzenie miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  UstalenieNumeruPorzadkowego: {
    title: 'Wniosek o ustalenie numeru porządkowego budynku',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  UsuniecieDrzew: {
    title: 'Wniosek o wydanie zezwolenia na usunięcie drzew lub krzewów',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  WypisZMpzp: {
    title: 'Wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  WyrysZMpzp: {
    title: 'Wyrys z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  WypisZeStudium: {
    title: 'Wypis ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },  
  WyrysZeStudium: {
    title: 'Wyrys ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZaswiadczenieEMUIA: {
    title: 'Wniosek o wydanie zaświadczenia o ustalonym numerze porządkowym budynku',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZaswiadczenieStudium: {
    title: 'Wniosek o wydanie zaświadczenia ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZezwolenieAlkohol: {
    title: 'Wniosek o wydanie zezwolenia na sprzedaż napojów alkoholowych',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZgloszeniePOS: {
    title: 'Zgłoszenie do ewidencji przydomowych oczyszczalni ścieków do 5 m2 na dobę',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZmianaCeluPublicznego: {
    title: 'Wniosek o zmianę decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZmianaSUIKZP: {
    title: 'Wniosek o zmianę studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  ZmianaWarunkowZabudowy: {
    title: 'Wniosek o zmianę decyzji o warunkach zabudowy',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  decyzje_su: {
    title: 'Wniosek o wydanie decyzji środowiskowej',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  invest_contact: {
    title: 'List intencyjny inwestora',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  uproszczony_wypis: {
    title: 'Uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  wmc: {
    title: 'Wniosek o miejsce na cmentarzu',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  wypis_i_wyrys: {
    title: 'Uproszczony wypis i wyrys z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
  wziulicp: {
    title: 'Wniosek o wydanie decyzji o warunkach zabudowy lub decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: {},
  },
};



// WEBPACK FOOTER //
// src/routes/sprawy/Sprawy.js